<template>
  <!-- 形式"< 1 2 3  ...  6>"" -->
   <div class="pagePagination">
    <span>&lt;</span>
    <span>1</span>
    <span>2</span>
    <span>3</span>
    <span>...</span>
    <span>{{ props.totalpage }}</span>
    <span>&gt;</span>
   </div>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'pagePagination',
  props: ['islastpage', 'totalpage'],
  setup (props) {
    const hasNextPage = ref(true)
    hasNextPage.value = !props.islastpage
    // console.log(props)

    return {
      props
    }
  }
}
</script>

<style lang="less" scoped>
.pagePagination {
  display: flex;
  // gap: 100px;
  column-gap: 10px;
  span {
    flex: 1;
    border-radius: 10px;
    border: 1 solid;
    background-color: rgb(255, 255, 255);
    padding: 10px;
    text-align: center;
  }
}
</style>>
